import { render } from "./FPluginBaList.vue?vue&type=template&id=e4c18efc&scoped=true"
import script from "./FPluginBaList.vue?vue&type=script&lang=js"
export * from "./FPluginBaList.vue?vue&type=script&lang=js"

import "./FPluginBaList.vue?vue&type=style&index=0&id=e4c18efc&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4c18efc"]])

export default __exports__